<template>
  <div>
    <Banner :banner="banner" />
    <div class="news-detail">
      <TypeMenu :menu="type" />
      <div class="container">
        <div class="title">{{newdetail.TITLE}}</div>
        <div class="content" v-html="newdetail.CONTENT"></div>
        <Btn @click="back" />
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
import Btn from '@/components/Btn.vue'
import TypeMenu from '@/components/TypeMenu.vue'
import { mapState } from 'vuex'
import Scrollbar from 'smooth-scrollbar';
export default {
  components: {
    Banner,
    Btn,
    TypeMenu
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      langNewtype: state => state.langNewtype,
      currentnewtid: state => state.currentnewtid
    }),
    type(){
      return this.langNewtype[this.lang]
    }
  },
  data() {
    return {
      banner: {
        img: "/images/locals/newsbanner.jpg",
        img_loading: "/images/locals_sm/newsbanner.jpg",
        smallimg: "/images/locals/smallnewsbanner.jpg",
        smallimg_loading: "/images/locals_sm/smallnewsbanner.jpg",
        content: {
          cn: "新闻资讯",
          en: "news"
        }
      },
      newdetail: {
        TITLE: '',
        NOTETIME: '',
        CONTENT: ''
      }
    }
  },
  mounted(){
    Scrollbar.initAll();
    const id = this.$route.params.id
    const url = `/php/new.php?nid=${id}`
    this.$$axios.get(url).then(res => {
       console.log(res.data)
      this.newdetail = res.data
    })
  },
  methods: {
    back(){
      this.$router.back(-1)
    }
  }
}
</script>

<style scoped>
.news-detail{
  padding: 50px 0;
  max-width: 1500px;
  margin: 0 auto;
}
.news-detail .container{
  max-width: 1310px;
  margin: 50px auto 0;
  padding: 4%;
  background-color: #fafafa;
}
.news-detail .container .title{
  text-align: center;
  font-size: 25px;
  color: #000;
  padding: 40px 0;
  border-bottom: 1px solid #e5e5e5;
}
.news-detail .container .content{
  padding: 40px 0;
  font-size: 16px;
  color: #454545;
  line-height: 30px;
}
</style>


